module.exports = __webpack_public_path__ + "static/bo-and-marcus-9181a5b2e1adfe252963cffd58e0e3ff.jpeg";